import React,{ useState,}from 'react'
import { Modal,Form,App, Input} from 'antd';
import { usePingfenAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
import MyEditor from '../../cpn/MyEditor';
function RateAdd(props) {    
    const {message} = App.useApp()
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = usePingfenAddMutation()
    const [info,setInfo] = useState({        
        'pf_xm_id': props.bxm_id,
        'pf_xm_name': props.bxm_name,
        'pf_xq_id': props.bxmxq_id,
        'pf_xq_name': props.bxmxq_name,
        'pf_bb_id': props.bxmbb_id,
        'pf_bb_name':props.bxmbb_name,
        'pf_num': '',
        'pf_name': '',
        'pf_content': '',
        'pf_state': '1',
        'pf_uid': props.eu_id,
        'pf_uname': props.eu_name,
        'pf_yh_id': props.yh_id,
        'pf_yh_name': props.yh_name,
    });
    return (
            <>
                <a
                    onClick={() => {setOpen(true)}}
                ><PlusSquareOutlined />  新增界面</a>
                <Modal
                    width={1000}
                    open={open}
                    title='新增界面'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add(info).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <Form.Item
                            name="pf_name"
                            label="名称"
                            wrapperCol={{ span: 20 }}
                            rules={[{ required: true, message: '请输入名称' }]}
                        >
                            <Input onChange={(e) => { setInfo(prevState => ({ ...prevState, pf_name: e.target.value }))}}/>
                        </Form.Item>
                        <Form.Item
                            name="pf_num"
                            label="界面"
                            wrapperCol={{ span: 10 }}
                            rules={[{ required: true, message: '请输入界面' }]}
                        >
                            <Input onChange={(e) => { setInfo(prevState => ({ ...prevState, pf_num: e.target.value }))}}/>
                        </Form.Item>
                        <Form.Item
                            name="pf_content"
                            label="备注"
                            wrapperCol={{ span: 20 }}
                        >                            
                            <MyEditor
                                onChange={(e) => {
                                    setInfo(prevState => ({ ...prevState, pf_content: e }))
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
}

export default RateAdd